module.exports = __webpack_public_path__ + "img/d-xiuchang-nan.1e9a3bc2.jpg";